import type { MutableRefObject } from "react";
import type { DraggableSyntheticListeners } from "@dnd-kit/core";
import type { Atom } from "@tanstack/react-store";

/** The single draggable's handles, re-pointed at whatever was pressed. */
export interface DraggableApi {
    setNodeRef: (element: HTMLElement | null) => void;
    setActivatorNodeRef: (element: HTMLElement | null) => void;
    listeners: DraggableSyntheticListeners;
}

/** Written by the draggable, read by the press handlers. */
export type DraggableApiRef = MutableRefObject<DraggableApi | null>;

/** How a drag started: keyboard drags step and drop without animation. */
export type DragInput = "keyboard" | "pointer";

export const getDragInput = (activatorEvent: Event | null): DragInput =>
    activatorEvent instanceof KeyboardEvent ? "keyboard" : "pointer";

/** What the preview shows for the drag in progress. */
export interface DragPreviewInfo {
    label: string;
    input: DragInput;
}

/** One kind of drag (rows or columns) as the shared DndContext drives it. */
export interface DragKindController<TIndicator> {
    sourceRef: DraggableApiRef;
    indicator: Atom<TIndicator | null>;
    /** False when this kind didn't start the drag. */
    onStart: (activatorEvent: Event | null) => DragPreviewInfo | false;
    onEnd: () => void;
    onCancel: () => void;
}
